import * as React from "react";
const SvgIcPhoneMobile = props => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M19 23H5V1H19V23ZM8 19H16V5H8V19Z" fill="currentColor" /></svg>;
export default SvgIcPhoneMobile;